import { env } from '@/config/env';

import { ProjectsApi, TasksApi } from '@nablax/sdk';
import { client } from '@nablax/shared/lib';

export const projectsApi = new ProjectsApi(
  undefined,
  env.VITE_RESOURCE_SERVER_URL,
  client,
);

export const tasksApi = new TasksApi(
  undefined,
  env.VITE_RESOURCE_SERVER_URL,
  client,
);
